var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "wish-list-count",
      attrs: {
        href: _vm.urlWishList,
        rel: "nofollow",
        "aria-label": _vm.$translate("Ceres::Template.wishList")
      }
    },
    [
      _vm.wishListCount
        ? _c("span", { staticClass: "badge-right-count" }, [
            _vm._v(_vm._s(_vm.wishListCount))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("i", {
        staticClass: "fa",
        class: {
          "fa-heart-o": !_vm.wishListCount,
          "fa-heart text-primary": _vm.wishListCount
        },
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "d-none d-md-block" }, [_vm._v("Merkzettel")])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }